import React from 'react';
import Select, { components, Options } from 'react-select';
import Image from 'next/image';
import arrowDownIcon from '../../../assets/images/arrow-down.svg';
import arrowDownBlueIcon from '../../../assets/images/arrow-up-blue.svg';

interface SearchOption {
  readonly value: string;
  readonly label: string;
}

type Props = {
  options: Options<SearchOption>;
  isMultiSelect?: boolean;
  isEditable?: boolean | undefined;
  placeHolder?: string;
  onChange: (value: any) => void;
  value?: SearchOption;
  onReset?: () => void;
};

function DropdownIndicator(props: any) {
  const { selectProps } = props;
  return (
    <components.DropdownIndicator {...props}>
      <div className="h-4 w-4 relative mr-1s">
        <Image src={selectProps.menuIsOpen ? arrowDownBlueIcon : arrowDownIcon} alt="Dropdown" />
      </div>
    </components.DropdownIndicator>
  );
}

function MenuListComponent(props: any) {
  const { children, onReset, getValue } = props;
  const value = getValue();
  return (
    <components.MenuList {...props}>
      <div>
        <div>{children}</div>
        {onReset && value && value.length > 0 && (
          <button
            type="button"
            onClick={onReset}
            className="text-sm pl-3 text-rp-primary-dark pt-4 pb-1 font-rp-pn-regular d:font-semibold"
          >
            Reset
          </button>
        )}
      </div>
    </components.MenuList>
  );
}

const defaultProps = {
  isMultiSelect: false,
  isEditable: false,
  placeHolder: 'Select',
  value: null,
  onReset: () => null,
};

export default function Dropdown({
  options,
  isMultiSelect,
  isEditable,
  placeHolder,
  onChange,
  value,
  onReset,
}: Props) {
  const [documentObject, setDocumentObject] = React.useState<Document>();

  React.useEffect(() => {
    setDocumentObject(document); // Hack needed for NextJS
  }, []);

  return (
    <div className="react-dropdown-component h-full">
      <Select
        options={options}
        value={value}
        className="react-dropdown-container"
        classNamePrefix="react-dropdown-options"
        placeholder={placeHolder}
        isMulti={isMultiSelect}
        isSearchable={isEditable}
        onChange={onChange}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        components={{
          DropdownIndicator,
          // eslint-disable-next-line react/no-unstable-nested-components
          MenuList: (props) => <MenuListComponent {...props} onReset={onReset} />,
        }}
        menuPortalTarget={documentObject?.body} // Hack to set zIndex properly
      />
    </div>
  );
}

Dropdown.defaultProps = defaultProps;
